import i18n, { InitOptions } from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { TranslationNamespaceBackend } from '@cas/utils/translationHelpers';
import { setLanguage } from '@customer/store/slices/authSlice';
import { store } from '@customer/store/store';

const version = process.env.NX_PUBLIC_MAGIC_VERSION ?? '1';

export const supportedLanguages = ['en', 'es', 'pt'];

export const isLanguageSetting = (value: string): value is string => {
  return Object.values(supportedLanguages).includes(value);
};

const initOptions: InitOptions = {
  ns: ['customer', 'common', TranslationNamespaceBackend],
  defaultNS: 'customer',
  fallbackNS: 'common',
  load: 'all',
  fallbackLng: 'en',
  supportedLngs: supportedLanguages,
  interpolation: {
    escapeValue: false,
  },
  backend: {
    loadPath: (lngs: string[], namespaces: string[]) => {
      if (namespaces.length === 1 && namespaces[0] === TranslationNamespaceBackend) {
        return `/api/resx/locales/{{ns}}/{{lng}}/translation.json?version=${version}`;
      }

      return `/resx/locales/{{ns}}/{{lng}}/translation.json?version=${version}`;
    },
  },

  detection: {
    order: ['localStorage', 'navigator'],
    lookupLocalStorage: 'language',
    lookupSessionStorage: 'language',
  },
};

i18n.use(LanguageDetector).use(Backend).use(initReactI18next);

i18n.on('languageChanged', lng => {
  store.dispatch(setLanguage(lng));
});

i18n.init(initOptions);

export default i18n;
